import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=66880534&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/advice.css?vue&type=style&index=0&id=66880534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66880534",
  null
  
)

export default component.exports